import { Product, SimproApi, SimproJob, SimproJobDetails, SimproJobDetailsInData } from '@/api';
import { AxiosError, AxiosResponse, AxiosStatic } from 'axios';
import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';

export class SimproService {
	constructor(private simproApi: SimproApi = new SimproApi()) {}

	public async getSimproJobDetails(
		simprojobs: SimproJobDetails[],
		axios: AxiosStatic,
		product?: Product,
	): Promise<SimproJobDetails[]> {
		const jobs: SimproJobDetails[] = [];
		const requests = [];
		for (const simproJob of simprojobs?.filter(
			(job: any) => !product?.id || job.productId === product?.id,
		)) {
			if (simproJob.id != null) {
				requests.push(
					this.simproApi
						.getSimproJobDetails(simproJob.id)
						.then((res: AxiosResponse<SimproJobDetailsInData>) => {
							if (res.data.data !== undefined) {
								// @ts-ignore
								if (res.data.data.original && res.data.data.original.errors) {
									// @ts-ignore
									throw { response: { data: { errors: res.data.data.original.errors } } };
								} else {
									if (!Array.isArray(res.data.data)) {
										// @ts-ignore
										if (!res.data.data.installer)
											// @ts-ignore
											res.data.data.installer = res.data.data.technician;
										jobs.push(res.data.data);
									}
								}
							}
						})
						.catch((err: AxiosError) => {
							console.error('simPRO Get Job Details Error:', err);
							const { errorMessage } = ApiUtils.handleApiError(
								err,
								`Error getting simPRO job with ID '${simproJob.id}'`,
								`getting simPRO job with ID '${simproJob.id}'`,
							);
							new Toast().makeToast(errorMessage, 'Error Getting simPRO Job', 'danger', true);
						}),
				);
			}
		}
		await axios.all(requests);
		return jobs;
	}
}
